<div class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Payment Methods</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div style="font-weight: 500;">{{amountDescription}} :</div>
                    <div style="font-weight: 600; color:#673AB7; font-size: 18px;">
                        {{ totalReceivable | currency:'INR' }}
                    </div>
                </div>
                <form [formGroup]="paymentForm">
                    <div #paymentsContainer formArrayName="payments">

                        <div *ngFor="let group of payments.controls; let i = index" [formGroupName]="i" class="p-3"
                            style=" margin: 4px 2px 8px 2px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.12); border-radius: 4px; ">

                            <div *ngIf="!group.get('isSelected')?.value" class="d-flex flex-column w-100"
                                style="gap:0.5rem;">
                                <div class="d-flex align-items-center" style="gap: 0.5rem;">
                                    <input #amountInput appAutofocus type="number" class="form-control" placeholder="Enter Amount"
                                        formControlName="amount" style="width: 65%;" />

                                    <button *ngIf="group.get('firstTimeSelection')?.value"
                                        (click)="clearPaymentMethod(i)" style="width: 35%;color: #808080;border-color: #808080;opacity: 0.6;"
                                        class="btn btn-outline-secondary">Clear</button>

                                    <button *ngIf="!group.get('firstTimeSelection')?.value"
                                        (click)="cancelPaymentMethod(i,{ method: group.get('method')?.value, amount: group.get('amount')?.value})"
                                        style="width: 35%;color: #808080;border-color: #808080;opacity: 0.6;" class="btn btn-outline-secondary">Cancel</button>
                                </div>
                                <div class="d-flex flex-wrap align-items-center" style="gap: 0.5rem;">
                                    <span [class.selected]="isMethodSelected(method,i)" [class.disabled-chip]="!group.get('amount')?.value || (disableMethodSelect && !isMethodSelected(method, i))"
                                        class="method-chip d-flex align-items-center justify-content-center" style="font-size: 13px; gap: 0.25rem;"
                                        *ngFor="let method of paymentMethods" (click)="selectPaymentMethod(method,i)">
                                        <div class="d-flex align-items-center justify-content-center"
                                            [style.background]="getMethodColor(method?.Method)" style="border-radius: 20px; height: 23px; width: 23px;">
                                            <i [ngClass]="getMethodIcon(method?.Method)"
                                                style="font-size: 12px; color: #fff;" ></i>
                                        </div>
                                        {{ method.label }}
                                    </span>
                                </div>
                            </div>

                            <div *ngIf="group.get('isSelected')?.value"
                                class="d-flex align-items-center justify-content-between" style="gap: 0.5rem;">
                                <div class="d-flex align-items-center">
                                    <button [ngClass]="disableMethodDelete ?'disable-element':'' " type="button"
                                        class="btn btn-outline-danger text-danger btn-sm flex-shrink-0 p-0"
                                        style="border: none; " (click)="removePayment(i)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                                <div class="d-flex align-items-center flex-nowrap" style="gap: 0.5rem;width: 80%;" (click)="editPaymentMethod(i)">
                                    <div class="flex-grow-1 d-flex align-items-center min-width-0"
                                        style="color: #673ab7; font-size: 15px; font-weight: 500;">
                                        <div class="d-flex align-items-center justify-content-center mr-1"
                                            [style.background]="getMethodColor(group.get('method')?.value?.Method)" style="border-radius: 20px; height: 30px; width: 30px;">
                                            <i [ngClass]="getMethodIcon(group.get('method')?.value?.Method)"
                                                style="font-size: 16px; color: #fff;"></i>
                                        </div>
                                        <span class="text-ellipsis">
                                            {{ group.get('method')?.value?.label }}
                                        </span>
                                    </div>

                                    <div class="text-ellipsis flex-shrink-0"
                                        style="color: #000;font-size: 15px; font-weight: 500;">
                                        {{group.get('amount')?.value | currency:'INR'}}</div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <button type="button"
                                        class="btn btn-outline-danger text-secondary btn-sm flex-shrink-0 p-0"
                                        style="border: none; " (click)="editPaymentMethod(i)"
                                        [disabled]="!isAllPaymentsValid">
                                        <i class="bi bi-chevron-double-down"></i>
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="d-flex align-items-center justify-content-center my-3">
                        <button [ngClass]="disableAddMore?'disable-element':'' " type="button" (click)="addPayment()"
                            class="btn btn-link" style="color:#673AB7;font-weight: 600;border: 1px solid #673ab7;"
                            [disabled]="!isAllPaymentsValid">
                            <i class="fa fa-plus"></i> Add More
                        </button>
                    </div>

                </form>
                <div class="d-flex justify-content-between mb-2">
                    <div style="font-weight: 500;">Balance to enter :</div>
                    <div [ngClass]="totalMatchedReceivable ? 'text-danger': 'text-success'" style="font-weight: 600;">
                        {{ totalReceivable - totalAmount | currency:'INR' }}
                    </div>
                </div>
                <div *ngIf="totalCashReceived" class="d-flex justify-content-between mb-2">
                    <div style="font-weight: 500;">Received Cash :</div>
                    <div>
                        {{ totalCashReceived | currency:'INR' }}
                    </div>
                </div>
                <div *ngIf="getChangeToReturn()" class="d-flex justify-content-between mb-2">
                    <div style="font-weight: 500;">Change to Return :</div>
                    <div>
                        {{ getChangeToReturn() | currency:'INR' }}
                    </div>
                </div>
                <small *ngIf="paymentMethods.length == 0" class="text-danger">
                    No payment methods available 
                </small>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal"
                    (click)="onClose()" style="color: #808080;border-color: #808080;opacity: 0.6;">Cancel</button>
                <button type="button" class="btn btn-primary"
                    style="background-color:#673AB7; color:#fff; border-color:#673AB7;"
                    [disabled]="isConfirmPaymentDisabled" (click)="onSubmit()">{{confirmButtonTitle}}</button>
            </div>


            <!-- Overlay when no payment methods -->
            <div *ngIf="!loading && paymentMethods.length === 0"
                class="no-methods-overlay d-flex flex-column align-items-center justify-content-center">


                <button type="button" class="close overlay-close-btn" aria-label="Close" (click)="onClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            
                <div class="overlay-message text-center">
                    <i class="fa fa-info-circle mb-2" style="font-size: 35px; color: #888;"></i>
                    <h5 class="mb-1" style="font-weight: 600; color: #555;">
                        No Payment Modes Configured
                    </h5>
                    <p class="text-muted" style="font-size: 14px;">
                        Please configure payment modes to proceed
                    </p>
                </div>
            </div>

        </div>
    </div>
</div>